import { withTaxIdBesideYearBuilt } from '../../shared';
import type { ListingLocaleOverrides } from '../base';

export const OHOverrides: ListingLocaleOverrides = {
  locale: 'OH',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: withTaxIdBesideYearBuilt,
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
          },
        },
      },
    },
  },
};
